import {Container} from "../../components/LayoutHelpers";
import {CTA} from "../../components/CTA";
import React from "react";
import "./CTASection.css"

export default function CTASection() {
    return <section aria-label="Contacto">
        <Container><CTA /></Container>
    </section>
}